const printConstants = {
    // Using 150 DPI
    // [W x H]
    A4: { portrait: [1240, 1754], landscape: [1754, 1240] },
    A5: { portrait: [874, 1240], landscape: [1240, 874] },
  };
  
  export default printConstants;
  